(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qm-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('qm-technology-navigation')) {
  customElements.define('qm-technology-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const button = this.querySelector('[data-qm-tech-toggle]');
      const panel = this.querySelector('[data-qm-tech-panel]');
      if (!button || !panel) return;
      const close = () => { panel.hidden = true; button.setAttribute('aria-expanded','false'); };
      button.addEventListener('click', () => { panel.hidden = !panel.hidden; button.setAttribute('aria-expanded',String(!panel.hidden)); }, { signal });
      document.addEventListener('click', event => { if (!this.contains(event.target)) close(); }, { signal });
      this.addEventListener('keydown', event => { if (event.key === 'Escape' && !panel.hidden) { close(); button.focus(); } }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
